<quick-card
  [routerLink]="['./users']"
  [uid]="'users-card'"
  [heading]="'Users*'"
  [headingColor]="'accent'"
  [loader]="loader"
  [hasRouterOutlet]="true"
  [headingIconKey]="'person'"
  [innerContentTemplate]="results"
  [matTooltip]="'Manage users, available to system users only'"
></quick-card>

<ng-template #results let-content=content>
  {{content['countTotal']}}
</ng-template>
